<template>
    <button class="reset-button" :class="{ rotating: isRotating }" @click="handleClick" title="Reset to original">
        <i class="fa fa-undo"></i>
    </button>
</template>

<script>
export default {
    name: "ResetButton",
    data() {
        return {
            isRotating: false,
        };
    },
    methods: {
        handleClick() {
            this.isRotating = true;
            this.$emit("reset");

            // Remove rotation class after animation duration
            setTimeout(() => {
                this.isRotating = false;
            }, 600); // Match duration in CSS
        },
    },
};
</script>

<style scoped>
.reset-button {
    background: none;
    border: none;
    color: lightgray;
    cursor: pointer;
    font-size: 1rem;
    outline: none;
    transition: color 0.3s ease;
}

.reset-button:hover {
    color: gray;
}

.rotating i {
    animation: rotate360 0.6s ease;
}

@keyframes rotate360 {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(-360deg);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Buttons/ResetIconButton.vue